// extracted by mini-css-extract-plugin
export var absolute = "loadingOverlay-module--absolute--46ac8";
export var icon = "loadingOverlay-module--icon--d38d2";
export var noBackground = "loadingOverlay-module--noBackground--c4789";
export var spin = "loadingOverlay-module--spin--0cb81";
export var wrapper = "loadingOverlay-module--wrapper--79a8d";